export { default as TypingMultiline } from './TypingMultiline';
export * from './types';

import Typing from './Typing';
export default Typing;
